import { render, staticRenderFns } from "./GrcDB.vue?vue&type=template&id=21a859e0&scoped=true&"
import script from "./GrcDB.vue?vue&type=script&lang=js&"
export * from "./GrcDB.vue?vue&type=script&lang=js&"
import style0 from "./GrcDB.vue?vue&type=style&index=0&id=21a859e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a859e0",
  null
  
)

export default component.exports